export interface PageableListV2Dto<T> {
  data?: T[];
  offset?: number;
  limit?: number;
  total?: number;
}

export interface PageableListV3Dto<T> {
  statusCode?: number;
  data?: T[];
  meta?: PageableListMetaDto;
  message?: string;
}

export interface PageableListMetaDto {
  offset?: number;
  limit?: number;
  total?: number;
}
